import React from 'react';

// assets

// services

// props

// components
import { DefaultButton, Dialog, DialogType, MessageBarType, PrimaryButton, Stack, TextField } from '@fluentui/react';
import Text from '../../typography/text';
import { useStore } from '../../../stores/root';
import UserService from '../../../services/users/user';
import LoadingComponent from '../../feedbacks/loading';
import SimpleMessageBarComponent from '../../feedbacks/simpleMessageBar';

type PasswordConfirmationProps = {
    onConfirmed(): void;
    onRejected?(): void;
    onCancelled(): void;
}

const PasswordConfirmation: React.FC<PasswordConfirmationProps> = (props: PasswordConfirmationProps) => {
    const { user } = useStore();

    const [confirming, setConfirming] = React.useState<boolean>(false);
    const [password, setPassword] = React.useState<string>("");
    const [error, setError] = React.useState<string | undefined>();

    const _onSubmit = async () => {
        setError(undefined);
        setConfirming(true);

        try {
            const confirmed = await UserService.confirmPassword(password);
            if (confirmed) {
                props.onConfirmed();
            } else {
                setError("Password does not matched.");
                setConfirming(false);

                if (props.onRejected) {props.onRejected();}
            }
        } catch(e) {
            setConfirming(false);
            setError("Sorry, we encounter an issue. Please try again. If the error occurs, please contact support team.");
        }
    }

    return <Dialog hidden={false}
        dialogContentProps={{
            type: DialogType.largeHeader,
            title: "Confirm Password"
        }}
        modalProps={{ isBlocking: true }} >
        <Stack tokens={{ childrenGap: 20 }}>
            {error ? <SimpleMessageBarComponent properties={{
                type: MessageBarType.error,
                text: error,
                icon: 'Cancel'
            }} /> : null}
            <Text size={'small'}>You are going to perform a confidential action. Therefore, to ensure security for all users, you have to confirm your password that you use to login before performing this action.</Text>
            <TextField label={"Email"}
                disabled={true}
                value={user.data?.email || ""} />
            <TextField type={'password'}
                label={"Confirm password"}
                value={password}
                required={true}
                errorMessage={password.trim() === "" ? "This field is required" : undefined}
                onChange={(evt, value) => setPassword(value || "")} />
            <Stack horizontal tokens={{ childrenGap: 10 }}>
                {!confirming ? <>
                    <PrimaryButton disabled={password.trim() === ""} text={"Confirm"} onClick={_onSubmit} />
                    <DefaultButton onClick={() => props.onCancelled()} text={"Cancel"} />
                </> : null}
                {confirming ? <LoadingComponent label={"Working on it ..."} labelPosition='right' spinnerPosition={'baseline'} /> : null}
            </Stack>
        </Stack>
    </Dialog>
}

export default PasswordConfirmation;